import Billboard, { ICustomBillboardProps } from './Billboard';

export const CustomBillboard = (props: ICustomBillboardProps & {isCameraOrbiting?: boolean, rotateNoBillboardOuterGroup?: boolean}) => {
    const { isCameraOrbiting = false, rotateNoBillboardOuterGroup = false, ...restProps } = props;
	const { follow = false, lockY: _lockY = false, children, rotation, ...groupProps } = restProps;

	return (
        <>
            {!follow ? 
                <group {...groupProps} rotation={rotateNoBillboardOuterGroup ? rotation: undefined}>
                    <group rotation={rotateNoBillboardOuterGroup ? undefined : rotation}>
                        {children}
                    </group>
                </group> : 
                <Billboard {...restProps} cancelParentYRotation={!isCameraOrbiting} >
                    {children}  
                </Billboard>
            }
        </>
    );
};

export default CustomBillboard;
